"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SVGTextStyle = _interopRequireDefault(require("./SVGTextStyle"));

var _default = (0, _styledComponents.default)(_SVGTextStyle.default).withConfig({
  displayName: "SVGTextIconStyle",
  componentId: "vzmwap-0"
})(["font-family:'spacesword' !important;font-feature-settings:'liga';font-size:110%;font-variant:normal;font-weight:normal !important;letter-spacing:0;text-transform:none;"]);

exports.default = _default;
module.exports = exports.default;